var map = {
	"./01.svg": "3ad3",
	"./02.svg": "854d",
	"./icon_arrow.svg": "5808",
	"./icon_close.svg": "bb9c",
	"./icon_credit-card.svg": "bd8f",
	"./icon_expand.svg": "7f55",
	"./icon_nav-arrow.svg": "14b4",
	"./icon_pencil.svg": "5f0a",
	"./icon_play-btn.svg": "f31c",
	"./icon_ticket.svg": "986a",
	"./roi/icon_briefcase.svg": "de94",
	"./roi/icon_building.svg": "7466",
	"./roi/icon_dollar.svg": "bfc6",
	"./roi/icon_eye.svg": "2003",
	"./roi/icon_heart.svg": "8eeb",
	"./roi/icon_person.svg": "ed68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";